import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M71.758 59.293L68.61 21.514a2.93 2.93 0 00-2.92-2.686H9.206a2.93 2.93 0 00-2.92 2.686L.01 96.827A2.929 2.929 0 002.93 100h50c10.398 0 18.828-8.43 18.828-18.828V59.293z"
        fill="#FF405C"
      />
      <path
        d="M65.69 18.828H37.448V100h15.481c10.399 0 18.828-8.43 18.828-18.828V59.293L68.61 21.514a2.93 2.93 0 00-2.92-2.686z"
        fill="#D01273"
      />
      <path
        d="M50 37.24a2.93 2.93 0 01-2.93-2.93V15.482c0-5.306-4.316-9.623-9.622-9.623s-9.622 4.317-9.622 9.623V34.31a2.93 2.93 0 01-5.86 0V15.482C21.966 6.945 28.911 0 37.448 0 45.985 0 52.93 6.945 52.93 15.482V34.31A2.93 2.93 0 0150 37.24z"
        fill="#FFEC29"
      />
      <path
        d="M50 69.037c-5.076 0-9.206 4.13-9.206 9.205 0 5.076 4.13 9.206 9.206 9.206s9.206-4.13 9.206-9.206-4.13-9.206-9.206-9.206zm0 12.551a3.35 3.35 0 01-3.346-3.346A3.35 3.35 0 0150 74.896a3.35 3.35 0 013.346 3.346A3.35 3.35 0 0150 81.588z"
        fill="#E6E6E6"
      />
      <path
        d="M24.896 43.932c-5.076 0-9.206 4.13-9.206 9.206s4.13 9.206 9.206 9.206 9.206-4.13 9.206-9.206-4.13-9.206-9.206-9.206zm0 12.552a3.35 3.35 0 01-3.346-3.346 3.35 3.35 0 013.346-3.346 3.35 3.35 0 013.346 3.346 3.35 3.35 0 01-3.346 3.346zM23.066 83.668a2.93 2.93 0 01-.457-4.118l25.104-31.38a2.93 2.93 0 114.575 3.66L27.184 83.21c-.96 1.201-2.795 1.517-4.118.458z"
        fill="#F5F5F5"
      />
      <path
        d="M37.448 70.38l14.84-18.55a2.93 2.93 0 00-4.576-3.66L37.448 61v9.38z"
        fill="#E6E6E6"
      />
      <path
        d="M50 37.24a2.93 2.93 0 01-2.93-2.93V15.482c0-5.306-4.316-9.623-9.622-9.623V0c8.536 0 15.481 6.945 15.481 15.482V34.31A2.93 2.93 0 0150 37.24z"
        fill="#FFCB00"
      />
      <path
        d="M97.07 100H53.138a2.93 2.93 0 01-2.89-3.411l6.276-37.657a2.93 2.93 0 012.89-2.448h31.38a2.93 2.93 0 012.89 2.448L99.96 96.59A2.928 2.928 0 0197.07 100z"
        fill="#3C3A42"
      />
      <path
        d="M93.683 58.932a2.93 2.93 0 00-2.89-2.448h-15.69V100H97.07a2.93 2.93 0 002.89-3.411l-6.277-37.657z"
        fill="#23232D"
      />
      <path
        d="M81.38 68.62a2.93 2.93 0 01-2.93-2.93V53.138a3.347 3.347 0 00-6.693 0V65.69a2.93 2.93 0 01-5.86 0V53.138c0-5.04 4.074-9.206 9.207-9.206 5.028 0 9.206 4.062 9.206 9.206V65.69a2.93 2.93 0 01-2.93 2.93z"
        fill="#FFEC29"
      />
      <path
        d="M81.38 68.62a2.93 2.93 0 01-2.93-2.93V53.138a3.347 3.347 0 00-3.347-3.347v-5.859c5.028 0 9.206 4.062 9.206 9.206V65.69a2.93 2.93 0 01-2.93 2.93z"
        fill="#FFCB00"
      />
    </svg>
  )
}

export default SvgComponent
